// extracted by mini-css-extract-plugin
export default {"link":"WD-z","disabled":"XD-z"};